//GLOBAL - components from npm
import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, useFilters } from "react-table";
import { ReactComponent as FavoriteIcon } from "../../build/images/icons/favoritetwo.svg";
import { ReactComponent as FavoriteEnableIcon } from "../../build/images/star.svg";
import { ReactComponent as LeadIcon } from "../../build/images/icons/leadmail.svg";
import { ReactComponent as TrashIcon } from "../../build/images/trashtwo.svg";
import { ReactComponent as SmsIcon } from "../../build/images/smsgrain.svg";
// import { format } from "date-fns";
import TablePagination from "@mui/material/TablePagination";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import { ptBR } from "@mui/material/locale";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import OrderButton from "../order-button/OrderButton";

//STYLES
import "./table.css";

//COMPONENTS
// import { OrderButton, Typography } from "./../../../components/general";
// import { Tippy } from "../../feedback";

//SERVICES - api, conectors...

//GLOBAL STATE - redux, env...
// import { useDispatch } from "react-redux";
// import { setInitialSort } from "../../../store/tableFilters";

//ASSETS - icons, images...

export default function Table({
  className = "",
  data,
  columns,
  fixedHeader,
  fixedFirstColumn,
  filtersActive,
  emptyState = false,
  setEmptyState = () => null,
  controlledTableState,
  screen = "",
  initialState,
  rowShadowLine = false,
  classDivWrapperTable = null,
  //   {
  //     sortBy: [
  //         {
  //             id: 'date',
  //             desc: true
  //         },
  //         {
  //             id: 'status',
  //             desc: false
  //         },
  //     ]
  // }}
  ...others
}) {
  // DEFAULT PROPS
  const defaultData = useMemo(() => [], []);

  // if (!data || !columns) {
  //   data = defaultData;
  //   columns = defaultColumns;
  // }

  //GENERAL
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setFilter,
  } = useTable(
    {
      columns,
      data,
      useControlledState: (state) => {
        // console.debug('state: ', state);
        return {
          ...state,
          ...controlledTableState,
        };
      },
      initialState: initialState,
    },
    useFilters,
    useSortBy,
  );

  const theme = useTheme();
  let checkMarkBox = false;

  //STATES
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const countPagination =
    parseInt(rows.length / rowsPerPage) +
    (rows.length % rowsPerPage !== 0 ? 1 : 0);
  // const [testeRoll, setTesteRoll] = useState("");

  //REDUX - Selectors
  // const dispatch = useDispatch();

  //FUNCTIONS
  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);

    if (screen === "manager_colaborators") {
      localStorage.setItem("rows_perpage_colaborators", event.target.value);
    } else if (screen === "manager") {
      localStorage.setItem("rows_perpage_services", event.target.value);
    } else if (screen === "manager_operators") {
      localStorage.setItem("rows_perpage_operators", event.target.value);
    } else if (screen === "manager_groupRow") {
      localStorage.setItem("rows_perpage_groupRow", event.target.value);
    } else if (screen === "npsTables") {
      localStorage.setItem("rows_perpage_npsTables", event.target.value);
    } else if (screen === "campaigns") {
      localStorage.setItem("rows_perpage_campaigns", event.target.value);
    }
  };

  function defaultLabelDisplayedRows({ from, to, count }) {
    return `${from}–${to} de ${count !== -1 ? count : `more than ${to}`} itens`;
  }

  const themeWithLocale = React.useMemo(
    () => createTheme(theme, ptBR),
    [ptBR, theme],
  );

  const displayHeader = (head) => {
    return head.display !== false;
  };

  const displayBody = (body) => {
    return body.column.display !== false;
  };

  // function handleInitialSort(columnInfo) {
  //   dispatch(
  //     setInitialSort({
  //       localStorageKey: "initialSorted",
  //       localStorageValue: [
  //         {
  //           id: columnInfo.id,
  //           desc: columnInfo.isSortedDesc,
  //         },
  //       ],
  //     })
  //   );
  // }

  function renderCellContent(cell, row, index) {
    if (cell.value) {
      if (cell.column.id === "actions_primary") {
        return (
          <div className="cell-content__container">
            <input
              type="checkbox"
              id={"cell" + index}
              className="cell-content__container-checkbox"
            />
            <div className="cell-content__container-icon">
              {row.values.actions_primary.config.favorite ? (
                <FavoriteEnableIcon />
              ) : (
                <FavoriteIcon />
              )}
            </div>
          </div>
        );
      } else if (cell.column.id === "actions_secondary") {
        return (
          <div className="cell-content__container">
            {/* <TrashIcon /> */}
            <div className="cell-content__container-icon">
              {row.values.actions_primary.config.read ? (
                <LeadIcon />
              ) : (
                <SmsIcon />
              )}
            </div>
          </div>
        );
      } else if (
        cell.column.id === "sender" ||
        cell.column.id === "recipient" ||
        cell.column.id === "copy"
      ) {
        return (
          <span>
            {cell.value.data !== "" &&
            cell.value.data !== "null" &&
            cell.value.data !== null
              ? cell.value.data[0].toUpperCase() + cell.value.data.substring(1)
              : ""}
          </span>
        );
      } else {
        if (
          screen === "manager" ||
          screen === "manager_colaborators" ||
          screen === "manager_operators" ||
          screen === "manager_groupRow" ||
          screen === "campaigns"
        ) {
          return (
            <span
              className={
                cell.value.config.className
                  ? cell.value.config.className
                  : "cell-gray-text"
              }
            >
              {cell.value.data}
            </span>
          );
        } else {
          return <span>{cell.value.data}</span>;
        }
      }
    } else {
      return "";
    }
  }

  // function renderCell(row, index) {
  //   saveSortDesc(headerGroups);
  //   return row.cells.filter(displayBody).map((cell) => {
  //     // if (cell.value?.config.tippy) {
  //     if (cell.value) {
  //       return (
  //         <td
  //           {...cell.getCellProps()}
  //           className={`cell-ellipsis ${
  //             cell.value.config.cellColor ? cell.value.config.cellColor : ""
  //           }`}
  //         >
  //           {/* <Tippy content={cell.value.data}> */}
  //           <div className="cell-container">
  //             {renderCellContent(cell, row, index)}
  //           </div>
  //           {/* </Tippy> */}
  //         </td>
  //       );
  //     } else {
  //       return (
  //         <td {...cell.getCellProps()} className="cell-ellipsis">
  //           <div className={`cell-container`}>
  //             {renderCellContent(cell, row, index)}
  //           </div>
  //         </td>
  //       );
  //     }
  //   });
  // }

  function renderCell(row, index) {
    saveSortDesc(headerGroups);
    return row.cells.filter(displayBody).map((cell) => {
      if (cell.value && cell.value.config && cell.value.config.cellColor) {
        return (
          <td
            {...cell.getCellProps()}
            className={`cell-ellipsis ${
              cell.value.config.cellColor ? cell.value.config.cellColor : ""
            }`}
          >
            <div className="cell-container">
              {renderCellContent(cell, row, index)}
            </div>
          </td>
        );
      } else {
        return (
          <td {...cell.getCellProps()} className="cell-ellipsis">
            <div className="cell-container">
              {renderCellContent(cell, row, index)}
            </div>
          </td>
        );
      }
    });
  }

  function checkEmptyState() {
    if (!emptyState && rows.length === 0) {
      setEmptyState(true);
    } else if (emptyState && rows.length > 0) {
      setEmptyState(false);
    }
  }

  checkEmptyState();
  // #TOIMPROVE: remover a função de checar o empty state se conseguir ter acesso aos estado atual das linhas (após filtrado) fora do component table

  //USE EFFECTS
  useEffect(() => {
    if (screen === "npsTables" || screen === "campaigns") {
      setPage(0);
    }
  }, [rows.length]);

  useEffect(() => {
    let element = document.getElementById("mark_all_inputs");
    if (element) {
      element.addEventListener("click", function () {
        for (
          let i = 0;
          i <
          document.getElementsByClassName("cell-content__container-checkbox")
            .length;
          i++
        ) {
          if (document.getElementById(`cell${i}`)) {
            if (checkMarkBox)
              document.getElementsByClassName(
                "cell-content__container-checkbox",
              )[i].checked = false;
            else
              document.getElementsByClassName(
                "cell-content__container-checkbox",
              )[i].checked = true;
          }
        }
        checkMarkBox = !checkMarkBox;
      });
    }
    let rowsPerPage = 5;
    if (screen === "manager_colaborators") {
      rowsPerPage = localStorage.getItem("rows_perpage_colaborators");
      setRowsPerPage(rowsPerPage ? parseInt(rowsPerPage) : 5);
    } else if (screen === "manager") {
      rowsPerPage = localStorage.getItem("rows_perpage_services");
      setRowsPerPage(rowsPerPage ? parseInt(rowsPerPage) : 5);
    } else if (screen === "manager_operators") {
      rowsPerPage = localStorage.getItem("rows_perpage_operators");
      setRowsPerPage(rowsPerPage ? parseInt(rowsPerPage) : 5);
    } else if (screen === "manager_groupRow") {
      rowsPerPage = localStorage.getItem("rows_perpage_groupRow");
      setRowsPerPage(rowsPerPage ? parseInt(rowsPerPage) : 5);
    } else if (screen === "npsTables") {
      rowsPerPage = localStorage.getItem("rows_perpage_npsTables");
      setRowsPerPage(rowsPerPage ? parseInt(rowsPerPage) : 5);
    } else if (screen === "campaigns") {
      rowsPerPage = localStorage.getItem("rows_perpage_campaigns");
      setRowsPerPage(rowsPerPage ? parseInt(rowsPerPage) : 5);
    }
  }, []);

  function saveSortDesc(headerGroups) {
    if (headerGroups.length !== 0) {
      let findSort = headerGroups[0].headers.filter(
        (group) => group.isSorted === true,
      );
      if (findSort.length !== 0) {
        let sortMarked = {
          sort: findSort[0].id,
          sortDesc: findSort[0].isSortedDesc,
        };

        screen === "manager" &&
          localStorage.setItem("sortMarkedService", JSON.stringify(sortMarked));
        screen === "manager_colaborators" &&
          localStorage.setItem(
            "sortMarkedColaborators",
            JSON.stringify(sortMarked),
          );
        screen === "manager_operators" &&
          localStorage.setItem(
            "sortMarkedOperators",
            JSON.stringify(sortMarked),
          );
        screen === "manager_groupRow" &&
          localStorage.setItem(
            "sortMarkedGroupRow",
            JSON.stringify(sortMarked),
          );
        screen === "npsTables" &&
          localStorage.setItem("sortDealingRow", JSON.stringify(sortMarked));
        screen === "campaigns" &&
          localStorage.setItem("sortCampaigns", JSON.stringify(sortMarked));
      } else {
        screen === "manager" && localStorage.removeItem("sortMarkedService");
        screen === "manager_colaborators" &&
          localStorage.removeItem("sortMarkedColaborators");
        screen === "manager_operators" &&
          localStorage.removeItem("sortMarkedOperators");
        screen === "manager_groupRow" &&
          localStorage.removeItem("sortMarkedGroupRow");
        screen === "npsTables" && localStorage.removeItem("sortDealingRow");
        screen === "campaigns" && localStorage.removeItem("sortCampaigns");
      }
    }
  }

  return (
    <div className={`section-email-list ${className ? className : ""}`}>
      <div className={classDivWrapperTable ? classDivWrapperTable : ""}>
        <table
          className="table mail table--fixed-first-column"
          {...getTableProps()}
          cellSpacing={0}
          {...others}
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.filter(displayHeader).map((column) => {
                  // column.isSorted;
                  // column.isSorted && handleInitialSort(column);
                  return (
                    <th
                      {...column.getHeaderProps(
                        column.getSortByToggleProps({ title: column.Hint }),
                      )}
                      // style={{width: column.Header === 'Canais' ? '300px':'auto'}}
                    >
                      <div
                        className={`flex-container`}
                        // style={{
                        //   paddingLeft:
                        //     column.render("Header") === "Serviço" ||
                        //     column.render("Header") === "Atendentes"
                        //       ? "12px"
                        //       : 0,
                        // }}
                      >
                        <span className="table-header__title">
                          {column.render("Header")}
                        </span>
                        {column.canSort && (
                          <OrderButton
                            direction={
                              column.isSorted &&
                              (column.isSortedDesc ? "desc" : "asc")
                            }
                          />
                        )}
                      </div>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          {/* <tbody {...getTableBodyProps()}> */}
          {/* <div className="table-mail__tbody"> */}
          <tbody {...getTableBodyProps()}>
            {className !== "table-email"
              ? rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    prepareRow(row);
                    if (row.values.actions_primary)
                      return (
                        <tr
                          className={`${
                            row.values.actions_primary.config.read
                              ? "read"
                              : "unread"
                          } ${rowShadowLine ? "shadow-line" : ""}`}
                          {...row.getRowProps()}
                        >
                          {renderCell(row, index)}
                        </tr>
                      );
                    else
                      return (
                        <tr
                          className={`${rowShadowLine ? "shadow-line" : ""}`}
                          {...row.getRowProps()}
                        >
                          {renderCell(row, index)}
                        </tr>
                      );
                  })
              : rows.map((row, index) => {
                  prepareRow(row);
                  if (row.values.actions_primary)
                    return (
                      <tr
                        className={`${
                          row.values.actions_primary.config.read
                            ? "read"
                            : "unread"
                        } ${rowShadowLine ? "shadow-line" : ""}`}
                        {...row.getRowProps()}
                      >
                        {renderCell(row, index)}
                      </tr>
                    );
                  else
                    return (
                      <tr
                        className={`${rowShadowLine ? "shadow-line" : ""}`}
                        {...row.getRowProps()}
                      >
                        {renderCell(row, index)}
                      </tr>
                    );
                })}
          </tbody>
          {/* </div> */}
        </table>
      </div>

      <div
        className={"pagination-table"}
        style={{
          display: className === "table-email" ? "none" : "flex",
        }}
      >
        <ThemeProvider theme={themeWithLocale}>
          <TablePagination
            rowsPerPageOptions={
              className === "table-email"
                ? false
                : [
                    5,
                    10,
                    15,
                    25,
                    50,
                    100,
                    500,
                    { label: "All", value: rows.length },
                  ]
            }
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelDisplayedRows={defaultLabelDisplayedRows}
            backIconButtonProps={{ sx: { display: "none" } }}
            nextIconButtonProps={{ sx: { display: "none" } }}
            SelectProps={{
              MenuProps: { sx: { zIndex: 99999 } },
            }}
            sx={{ fontFamily: "Inter" }}
          />
        </ThemeProvider>

        <Stack spacing={2}>
          <Pagination
            id="pagination-numbers"
            count={countPagination}
            siblingCount={1}
            color="primary"
            onChange={handleChangePage}
            page={page + 1}
          />
        </Stack>
      </div>
    </div>
  );
}
